export default {
  edit: "status:edit",
  create: "status:create",
  delete: "status:delete",
  view: "status:view",
};
